import { TemplateCreate, TemplateListResponse, TemplateSummarySchema, TemplateVariablesUpdate, } from '@aeris/contracts';
import { request } from "./client.js";
export const fetchTemplates = async (accountId, signal) => TemplateListResponse.parse(await request(accountId === undefined
    ? '/api/v1/communication/templates'
    : `/api/v1/communication/templates?accountId=${accountId}`, { signal })).templates;
export const createTemplate = async (input) => TemplateSummarySchema.parse(await request('/api/v1/communication/templates', {
    method: 'POST',
    body: TemplateCreate.parse(input),
}));
/** Dá nome e exemplo às variáveis de um modelo que já existe — em especial um sincronizado da Meta sem nome nenhum. */
export const updateTemplateVariables = async (id, input) => TemplateSummarySchema.parse(await request(`/api/v1/communication/templates/${id}/variables`, {
    method: 'PATCH',
    body: TemplateVariablesUpdate.parse(input),
}));
//# sourceMappingURL=communication-templates.js.map